<!-- @format -->

<div
	class="availability hmf-display-flex hmf-flex-wrap hmf-justify-content-between hmf-align-content-center"
	[class]="showZipCodeAndStoreInMessage() ? 'no-explicit-height hmf-flex-column' : ''">
	@if (productAvailabilityData && !isComingSoon && !isOOS) {
		<div class="shipping-availability hmf-pb-xxxs">
			<homefield-icon
				[class]="shippingMessage?.class"
				height="10px"
				width="10px"
				[name]="shippingMessage?.icon">
			</homefield-icon>
			@if (showZipCodeAndStoreInMessage() && userZipCode()) {
				<span> {{ shippingMessage?.text }} to </span>
				<span
					hmf-action-text
					size="small"
					variant="secondary">
					{{ userZipCode() }}
				</span>
			} @else {
				<span> {{ shippingMessage?.text }}</span>
			}
		</div>
	}
	@if (selectedStoreName() && !isComingSoon && !isOOS) {
		<div class="store-availability hmf-pb-xxxs">
			<homefield-icon
				[class]="pickupMessage?.class"
				height="10px"
				width="10px"
				[name]="pickupMessage?.icon">
			</homefield-icon>
			@if (showZipCodeAndStoreInMessage()) {
				<span> {{ pickupMessage?.text }} at </span>
				<span
					hmf-action-text
					size="small"
					variant="secondary">
					{{ selectedStoreName() | titlecase }}
				</span>
			} @else {
				<span> {{ pickupMessage?.text }}</span>
			}
		</div>
	}
</div>
